import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class AlbinoSquidCorpse extends OrganicMobCorpse {
	static key = "AlbinoSquidCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): AlbinoSquidCorpse {
		const c = new AlbinoSquidCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
